import { Component, OnInit, Input } from '@angular/core';
import { AnexoCadastro } from '../models/anexo-cadastro';

@Component({
  selector: 'app-upload-arquivo',
  templateUrl: './upload-arquivo.component.html',
  styleUrls: ['./upload-arquivo.component.scss']
})
export class UploadArquivoComponent implements OnInit {
  @Input() anexo: AnexoCadastro = new AnexoCadastro();
  @Input() index: string;
  @Input() titulo: string;
  @Input() descricao: string;
  @Input() apelidoArquivo: string;
  @Input() obrigatorio: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onFileChanged(event) {
    this.anexo.selectedFile = event.target.files[0];
    this.anexo.arquivo = this.anexo.selectedFile.name;
  }

  removerAnexo(anexo: AnexoCadastro) {
    anexo.selectedFile = undefined;
    anexo.arquivo = undefined;
  }

}
